import React, {  Component } from 'react';

export default class GenericOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.flag && this.props.handleDialog(this.props.flag, false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        const {
            genericDialogHeading,
            genericDialogText,
            extraParagraph,
            defaultTop,
            width,
            buttons,
            handleYes,
            handleOk,
            customClass,
            showModalCloseButton
        } = this.props;
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="confirmApproveRequestDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow" style={{top: defaultTop ? 'initial' : 122, width: width || '30em'}}>
                    {showModalCloseButton && <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>}
                    <h2 className="title" dangerouslySetInnerHTML={{__html: genericDialogHeading}} />
                    <p className={customClass} dangerouslySetInnerHTML={{__html: genericDialogText}} />
					<p dangerouslySetInnerHTML={{__html: extraParagraph}} />

					{buttons && buttons.indexOf('no') !== -1?
						<div className="noButtonContainer">
							<a className="noButton blueButton fontSize-10" onClick={this.closeDialog.bind(this)}>No</a>
						</div>
						:null
					}
					{buttons && buttons.indexOf('yes') !== -1?
						<div className="yesButtonContainer">
							<a className="yesButton blueButton fontSize-10" onClick={handleYes.bind(this)}>Yes</a>
						</div>
						:null
					}
					{buttons && buttons.indexOf('cancel') !== -1?
						<div className="floatLeft">
							<a className="noButton blueButton fontSize-10" onClick={this.closeDialog.bind(this)}>Cancel</a>
						</div>
						:null
					}
					{buttons && buttons.indexOf('ok') !== -1?
						<div className="floatRight">
							<a className="blueButton noButton fontSize-10" onClick={handleOk?handleOk.bind(this):this.closeDialog.bind(this)}>Ok</a>
						</div>
						:null
					}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/genericOverlayDialog.js